import api from "./api";

const getShipping = async () => {

    const response = await api.get("/api/shipping");

    return response.data.data;

};

const addShipping = async(formData)=>{
    const response = await api.post(
        "/api/shipping",
        formData
    );

    return response.data;

}

const updateShipping = async(id,formData)=>{

    const response = await api.put(
        `/api/shipping/${id}`,
        formData
    );

    return response.data;

}

const deleteShipping = async(id)=>{

    const response = await api.delete(`/api/shipping/${id}`);

    return response.data;

}

export default{
    getShipping,
    addShipping,
    updateShipping,
    deleteShipping
}